import React, { Component } from 'react';
import { Field, withShouldComponentUpdate } from '../Forms';
import pick from 'lodash/pick';

class Select extends Component {
  render() {
    const { name, options, defaultValue, validate, required, id, className, children, selectLabel, emptyOption, multiple } = this.props;
    return (
      <Field
        name={name}
        defaultValue={defaultValue}
        validate={validate}
        required={required}
        component={({ value, trigger, validationError, active })=> {
          return (
            <select
              id={id}
              className={className}
              name={name}
              value={value}
              multiple={multiple}
              onChange={(e)=> {
                trigger([
                  { type: 'onChange', value: e.target.value },
                  { type: 'onValidate' },
                  { type: 'onTouched' },
                  { type: 'onDirty' }
                ]);
              }}
            >
              {emptyOption || (!value && typeof selectLabel !== 'undefined') ? (
                  <option value="" key="$$emtpy$$">{selectLabel || ''}</option>
              ) : null}
              {options ? options.map((option)=>{
                if(typeof option === 'string'){
                  return <option value={option} key={option}>{option}</option>
                }
                const { label, ...props } = option;
                const allowedProps = pick(props, ['disabled', 'label', 'selected', 'value']);
                return (<option {...allowedProps} key={props.value}>{label || option.value}</option>);
              }) : children}

            </select>
          )
        }}/>
    )
  }
}

export default withShouldComponentUpdate(Select);



// WEBPACK FOOTER //
// ./src/app/components/Forms/fields/Select.js